const SystemErase = () => (
    <section id="system-erase">
        <div className="container-fluid pt-2 pb-4 text-center">
            <div className="row justify-content-center align-content-center text-center my-4">
                <div className="col-xl-6 col-lg-7 col-md-8 col-11">
                    <p className="fs-2 lh-1">
                        But this offer?<br />
                        This page?<br />
                        It may not be here tomorrow.
                    </p>
                </div>
            </div>
            <div className="row align-items-center justify-content-center py-3 gg-bg-solid-yellow-light">
                <div className="col-10 text-center">
                    <h1 className="fw-bold">The system has tried to erase Dr. Hart’s work before and they will again.</h1>
                </div>
            </div>
            <div className="row align-items-center justify-content-center gg-bg-gradient-rb-h text-white pt-5">
                <div className="col-xl-6 col-lg-7 col-md-8 col-11">
                    <p>
                        <b>They’ve already shut down his practice.</b><br />
                        Scrubbed his name from networks.<br />
                        Blocked every attempt to publish what he’s discovered.
                    </p>
                    <p className="mt-4">So if you’re seeing this now, it means we got through.</p>
                    <p className="mt-4">But time is short.</p>
                    <p className="mt-4">
                        And every bottle takes time to craft. <br />
                        When this batch runs out, it could be months before it’s back.
                    </p>
                    <h3 className="fw-bold mt-4">Don't wait.</h3>
                    <p className="mt-4">
                        This is your moment.<br />
                        Your lifeline.<br />
                        Your chance to take back control.
                    </p>
                    <p className="fw-bold mt-4 pb-4">Before they take it away from you again.</p>
                </div>
            </div>
        </div>
    </section>
);

export default SystemErase;